/**
 * Enum representing whether the dermatoscope is attached or not.
 */
export enum DermatoscopeAttachedStatus {
  Attached = 0,
  Detached = 1,
}
